import React from 'react';
//import Tree from 'react-ui-tree';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import cx from 'classnames';
import randomstring from 'uuid/v4';

import Fab from '@material-ui/core/Fab';
import Chip from '@material-ui/core/Chip';

import TimeDialog from './TimeDialog';

import Tree from '../../../tree/Index';
import { AddIcon } from '../../../../images/icons/WrapSvg';

class DateTimeNodeTree extends React.Component {
    state = {
        tree: this.props.tree,
        programmingTree: this.props.programmingTree,
        openDialog: false,
        selected: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        const { tree, programmingTree } = props;
        if (tree !== state.tree || programmingTree !== state.programmingTree) {
            state.tree = tree;
            state.programmingTree = programmingTree;
            return state;
        }
        return null;
    }

    sortedTree = (tree) => {
        const hijos = [...tree.children]
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((c) => this.sortedTree(c));
        tree.children = hijos;
        return tree;
    };

    handleClickOpenDialog = (event) => {
        this.setState({ openDialog: true });
    };

    handleAddProgrammingTime = (times, week, nodesSelected) => {
        const arr = [...this.state.programmingTree];
        if (nodesSelected) {
            const { selected } = this.state;
            if (selected !== undefined) {
                const nodeDelete = arr.find((f) => f.local === parseInt(selected.node.id, 10));
                const toDelete = nodeDelete.days.map((e) => e.id).indexOf(selected.id);
                nodeDelete.days.splice(toDelete, 1);
            }

            if (nodesSelected && nodesSelected.length > 0) {
                nodesSelected.forEach((n) => {
                    const node = arr.find((f) => f.local === parseInt(n.id, 10));

                    let days = node && node.days ? node.days : [];
                    let day = days.find((f) => f.week.join() === week.join());

                    if (day && day.time) {
                        // eslint-disable-next-line array-callback-return
                        times.map((t) => {
                            if (day.time.find((i) => i === t) === undefined) {
                                day.time.push(t);
                            }
                        });
                    } else if (day && !day.time) {
                        console.error(day, times);
                    } else {
                        days = days.concat([
                            {
                                day: week.join(),
                                week: week,
                                time: times,
                                id: randomstring(),
                            },
                        ]);
                    }

                    const id = n && n.id ? n.id : randomstring();

                    if (node) {
                        const index = arr.map((p) => p.local).indexOf(parseInt(n.id, 10));
                        arr.splice(index, 1);
                    }

                    arr.push({
                        local: parseInt(n.id, 10),
                        node: n,
                        days: days,
                        id: id,
                    });
                });

                this.props.onChange(arr);
                this.setState({
                    openDialog: false,
                    selected: undefined,
                    programmingTree: arr,
                });
            } else {
                this.setState({ openDialog: false, selected: undefined });
            }
        } else {
            this.setState({ openDialog: false, selected: undefined });
        }
    };

    handleDelete = (nodeId, dayId) => () => {
        if(!this.props.disabled) {
            const arr = [...this.state.programmingTree];
            const node = arr.find((f) => f.local === parseInt(nodeId, 10));
            const day = node.days.find((f) => f.id === dayId);
            const index = node.days.indexOf(day);
            node.days.splice(index, 1);
            const toDelete = arr.indexOf(node);
            arr.splice(toDelete, 1);
            arr.push(node);
            this.props.onChange(arr);
            this.setState({ programmingTree: arr, edit: true });
        }
    };

    handleChipClick = (nodeId, dayId) => (event) => {
        if(!this.props.disabled) {
            const node = this.state.programmingTree.find((f) => f.local === parseInt(nodeId, 10));
            const day = node.days.find((f) => f.id === dayId);
            this.setState({
                openDialog: true,
                selected: {
                    node: node.node,
                    week: day.week,
                    times: day.time,
                    id: day.id,
                },
            });
        }
    };

    format = (str) => {
        const { intl } = this.props;
        if (str === 'L,M,X,J,V,S,D') {
            return intl.formatMessage({ id: 'ever' });
        } else {
            str = str.replace(/L/g, intl.formatMessage({ id: 'form_week_day_monday' }));
            str = str.replace(/M/g, intl.formatMessage({ id: 'form_week_day_tuesday' }));
            str = str.replace(/X/g, intl.formatMessage({ id: 'form_week_day_wednesday' }));
            str = str.replace(/J/g, intl.formatMessage({ id: 'form_week_day_thursday' }));
            str = str.replace(/V/g, intl.formatMessage({ id: 'form_week_day_friday' }));
            str = str.replace(/S/g, intl.formatMessage({ id: 'form_week_day_saturday' }));
            str = str.replace(/D/g, intl.formatMessage({ id: 'form_week_day_sunday' }));
            return str;
        }
    };

    getLabel = (t) => {
        if (this.props.showTime) return this.format(t.day) + ': ' + t.time.sort().join();
        else return this.format(t.day);
    };

    renderNode = (tree) => (node) => {
        const { info } = this.props;
        const enable =
            node &&
            node.id &&
            info &&
            info.security &&
            info.security.localPermits &&
            info.security.localPermits[node.id.toString()]
                ? info.security.localPermits[node.id.toString()].some(
                      (r) => r === '20' || r === '64',
                  )
                : info && info.security && info.security.globalPermits
                ? info.security.globalPermits.some((r) => r === '20' || r === '64')
                : undefined;
        const times = tree ? tree.find((f) => f.local === parseInt(node.id, 10)) : undefined;
        let myData = [];
        if (times) {
            myData = []
                .concat(times.days)
                .sort((a, b) => (a.day !== undefined ? a.day > b.day : -1));
        }
        return (
            <div className="flex_full_row align_center">
                <span
                    className={
                        times !== undefined && times.days !== undefined
                            ? 'barlow_regular_message tag'
                            : 'barlow_regular_message margin_left_12 flex_full_row'
                    }
                    onMouseDown={function(e) {
                        e.stopPropagation();
                    }}
                >
                    {node.name}
                </span>
                <div className="flex_auto_row wrap">
                    {myData &&
                        myData.map((t) => {
                            if (enable) {
                                return (
                                    <Chip
                                        key={t.id}
                                        label={this.getLabel(t)}
                                        onClick={this.handleChipClick(node.id, t.id)}
                                        onDelete={this.handleDelete(node.id, t.id)}
                                        onMouseDown={function(e) {
                                            e.stopPropagation();
                                        }}
                                        className="margin_left_12 chip c_white bg_bluish"
                                    />
                                );
                            } else {
                                return (
                                    <Chip
                                        key={t.id}
                                        label={this.getLabel(t)}
                                        onMouseDown={function(e) {
                                            e.stopPropagation();
                                        }}
                                        className="margin_left_12 chip c_white bg_bluish"
                                    />
                                );
                            }
                        })}
                </div>
            </div>
        );
    };

    renderCollapse = (collapsed) => {
        return (
            <span
                className={cx('collapse padding_top_12', collapsed ? 'caret-right' : 'caret-down')}
                onMouseDown={function(e) {
                    e.stopPropagation();
                }}
                onClick={this.handleCollapse}
            />
        );
    };

    onClickNode = (node) => {
        this.setState({
            active: node,
        });
    };

    render() {
        const { tree, programmingTree, openDialog, selected } = this.state;
        const { disabled } = this.props;
        return (
            <div className="width100">
                {!disabled &&
                    <Fab
                        className={'float_right z_index_dialog'}
                        color="primary"
                        aria-label="add"
                        onClick={this.handleClickOpenDialog}
                    >
                        <AddIcon />
                    </Fab>
                }
                <Tree
                    paddingLeft={40}
                    tree={this.sortedTree(tree)}
                    orderBy={'name'}
                    renderNode={this.renderNode(programmingTree)} // renderNode(node) return react element
                    renderCollapse={this.renderCollapse}
                    isNodeCollapsed={this.isNodeCollapsed}
                    disabled={disabled}
                />
                {openDialog && (
                    <TimeDialog
                        open={true}
                        showTime={this.props.showTime}
                        value={selected}
                        onClose={this.handleAddProgrammingTime}
                    />
                )}
            </div>
        );
    }
}

DateTimeNodeTree.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

DateTimeNodeTree = connect(
    mapStateToProps,
    null,
)(DateTimeNodeTree);

DateTimeNodeTree = injectIntl(DateTimeNodeTree);

export default DateTimeNodeTree;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/DateTimeNodeTree.js